"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const core_1 = require("@material-ui/core");
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const formik_1 = require("formik");
const RenderEdithTextField_1 = __importDefault(require("./RenderEdithTextField"));
const useStyles = core_1.makeStyles(() => ({
    headerSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    headerText: {
        fontSize: '1.1rem',
        textDecoration: 'underline',
    },
    fieldsContainer: {
        marginBottom: '2rem',
    },
    container: {
        margin: '2rem 0rem',
    },
    copyButton: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
}));
const ModalDLTracker = (props) => {
    const { isVisible, titleText, cancelText, confirmText, onCancel, onConfirm, addedUsers, removedUsers, newDLAdded, validationSchema, } = props;
    const formRef = react_1.useRef(null);
    const classes = useStyles();
    const handleSubmit = (values) => {
        onConfirm(values);
    };
    return (react_1.default.createElement(Dialog_1.default, { open: isVisible, onClose: onCancel, fullWidth: true, maxWidth: 'md' },
        titleText && (react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(DialogTitle_1.default, null,
                react_1.default.createElement(Box_1.default, null,
                    react_1.default.createElement(Typography_1.default, { variant: "subtitle1" }, titleText))),
            react_1.default.createElement(Divider_1.default, null))),
        react_1.default.createElement(formik_1.Formik, { innerRef: formRef, initialValues: {
                removedUsers: removedUsers,
                newAddedUsers: addedUsers,
                emptyField: '',
                newDLAddedReason: '',
                newDLAdded: newDLAdded,
            }, validationSchema: validationSchema, onSubmit: (initialValues) => handleSubmit(initialValues), enableReinitialize: true }, ({ errors, values, initialValues, submitForm, setFieldValue, setErrors }) => (react_1.default.createElement(formik_1.Form, null,
            react_1.default.createElement(DialogContent_1.default, null,
                (addedUsers === null || addedUsers === void 0 ? void 0 : addedUsers.length) > 0 && (react_1.default.createElement(Box_1.default, { className: classes.container },
                    react_1.default.createElement(Typography_1.default, { className: classes.headerText }, "Users Added to the Distribution List"),
                    react_1.default.createElement(core_1.Grid, { container: true, style: { marginTop: '1rem' } },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 5 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Name/Email")),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 3 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Reason")),
                        addedUsers.length > 1 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 1, md: 4, className: classes.copyButton },
                            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: () => {
                                    const textToCopy = values.newAddedUsers[0].reason;
                                    if ((textToCopy === null || textToCopy === void 0 ? void 0 : textToCopy.length) > 0) {
                                        for (let x = 1; x < values.newAddedUsers.length; x++) {
                                            setFieldValue(`newAddedUsers[${x}].reason`, textToCopy, false);
                                        }
                                        setErrors({ emptyField: '' });
                                    }
                                    else {
                                        setErrors({ emptyField: 'No text on first field' });
                                    }
                                } }, "Copy to all")))),
                    addedUsers.map((user, index) => {
                        return (react_1.default.createElement(Box_1.default, { style: { marginTop: '1.5rem' }, key: user.name },
                            react_1.default.createElement(core_1.Grid, { container: true },
                                react_1.default.createElement(core_1.Grid, { item: true, md: 5 },
                                    react_1.default.createElement(Typography_1.default, null, user.name),
                                    react_1.default.createElement(Typography_1.default, null, user.email)),
                                react_1.default.createElement(core_1.Grid, { item: true, md: 7 },
                                    react_1.default.createElement(formik_1.FastField, { component: RenderEdithTextField_1.default, name: `newAddedUsers[${index}].reason`, label: "Reason", value: values.newAddedUsers[index].reason }),
                                    errors.emptyField && index === 0 && (react_1.default.createElement(Typography_1.default, { style: { color: 'red', fontSize: '14px' } }, "Please Add some description to the first field to Copy to All"))))));
                    }))),
                (removedUsers === null || removedUsers === void 0 ? void 0 : removedUsers.length) > 0 && (react_1.default.createElement(Box_1.default, { className: classes.container },
                    react_1.default.createElement(Typography_1.default, { className: classes.headerText }, "Users Removed from the Distribution List"),
                    react_1.default.createElement(core_1.Grid, { container: true, style: { marginTop: '1rem' } },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 5 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Name/Email")),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 3 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Reason")),
                        removedUsers.length > 1 && (react_1.default.createElement(core_1.Grid, { item: true, xs: 1, md: 4, className: classes.copyButton },
                            react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: () => {
                                    const textToCopy = values.removedUsers[0].reason;
                                    for (let x = 1; x < values.removedUsers.length; x++) {
                                        setFieldValue(`removedUsers[${x}].reason`, textToCopy, false);
                                    }
                                } }, "Copy to all")))),
                    removedUsers.map((user, index) => {
                        return (react_1.default.createElement(Box_1.default, { style: { marginTop: '1.5rem' }, key: user.name },
                            react_1.default.createElement(core_1.Grid, { container: true },
                                react_1.default.createElement(core_1.Grid, { item: true, md: 5 },
                                    react_1.default.createElement(Typography_1.default, null, user.name),
                                    react_1.default.createElement(Typography_1.default, null, user.email)),
                                react_1.default.createElement(core_1.Grid, { item: true, md: 7 },
                                    react_1.default.createElement(formik_1.FastField, { component: RenderEdithTextField_1.default, name: `removedUsers[${index}].reason`, label: "Reason", value: values.removedUsers[index].reason })))));
                    }))),
                (newDLAdded === null || newDLAdded === void 0 ? void 0 : newDLAdded.length) > 0 && (react_1.default.createElement(Box_1.default, { className: classes.container },
                    react_1.default.createElement(Typography_1.default, { className: classes.headerText }, "Added Distribution List"),
                    react_1.default.createElement(core_1.Grid, { container: true, style: { marginTop: '1rem' } },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 5 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Distribution List Name")),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 2, md: 3 },
                            react_1.default.createElement(Typography_1.default, { style: { fontWeight: 'bold' } }, "Reason"))),
                    react_1.default.createElement(Box_1.default, { style: { marginTop: '1.5rem' } },
                        react_1.default.createElement(core_1.Grid, { container: true },
                            react_1.default.createElement(core_1.Grid, { item: true, md: 5 }, newDLAdded.map((dl) => (react_1.default.createElement(Typography_1.default, null, dl)))),
                            react_1.default.createElement(core_1.Grid, { item: true, md: 7 },
                                react_1.default.createElement(formik_1.FastField, { component: RenderEdithTextField_1.default, name: `newDLAddedReason`, label: "Reason" }))))))),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(DialogActions_1.default, null,
                cancelText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "secondary", onClick: onCancel, style: { maxHeight: '30px', minWidth: '160px' } }, cancelText)),
                confirmText && (react_1.default.createElement(Button_1.default, { variant: "contained", color: "primary", onClick: () => submitForm(), style: { maxHeight: '30px', margin: '0.5rem' } }, confirmText))))))));
};
ModalDLTracker.propTypes = {
    isVisible: prop_types_1.default.bool.isRequired,
    titleText: prop_types_1.default.string,
    cancelText: prop_types_1.default.string,
    confirmText: prop_types_1.default.string,
    onCancel: prop_types_1.default.any,
    onConfirm: prop_types_1.default.any,
    addedUsers: prop_types_1.default.any,
    removedUsers: prop_types_1.default.any,
    validationSchema: prop_types_1.default.any,
    newDLAdded: prop_types_1.default.any,
};
exports.default = ModalDLTracker;
